import { light } from '@mui/material/styles/createPalette';

const configUrlSecretaria = {
  SECRETARIA_CREATE_SITE: '/site/admin/cadastro/secretaria/create',
  SECRETARIA_EDIT_SITE: '/site/admin/cadastro/secretaria/edit/:id',
  SECRETARIA_LIST_SITE: '/site/admin/cadastro/secretaria/list',
  SECRETARIA_EDIT_LK_SITE: '/site/admin/cadastro/secretaria/edit/',

  SECRETARIA_CREATE_SABER: '/saber/cadastro/secretaria/create',
  SECRETARIA_EDIT_SABER: '/saber/cadastro/secretaria/edit/:id',
  SECRETARIA_LIST_SABER: '/saber/cadastro/secretaria/list',
  SECRETARIA_EDIT_LK_SABER: '/saber/cadastro/secretaria/edit/',

  SECRETARIA_API_EP: '/api/saber/admin/secretaria',
  SECRETARIA_FILTER_BY_SEARCH_EP: '/api/saber/admin/secretaria'
};

export default configUrlSecretaria;
